/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ServerStatus } from '../../models/server-status';

export interface ServerStatusControllerGetServerStatus$Params {
}

export function serverStatusControllerGetServerStatus(http: HttpClient, rootUrl: string, params?: ServerStatusControllerGetServerStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<ServerStatus>> {
  const rb = new RequestBuilder(rootUrl, serverStatusControllerGetServerStatus.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ServerStatus>;
    })
  );
}

serverStatusControllerGetServerStatus.PATH = '/server-status/server';
